import { DateString, Uuid } from '@/api/types';

export enum OutcomeType {
  Aborted = 'Aborted',
  DryRun = 'DryRun',
  Turndown = 'Turndown',
  Transplant = 'Transplant',
  DirectAcquisition = 'DirectAcquisition',
}

export enum DispositionReasonType {
  OrganNotSuitableForOCS = 'OrganNotSuitableForOCS',
  CancelledByTransMedics = 'CancelledByTransMedics',
  ByTxCenter = 'ByTxCenter',
  WithdrawnByOPO = 'WithdrawnByOPO',
  ErroneousCase = 'ErroneousCase',
  DCDDonorDidNotExpire = 'DCDDonorDidNotExpire',
  TurndownByTxCenter = 'TurndownByTxCenter',
  OCSContraindication = 'OCSContraindication',
  DeviceMalfunction = 'DeviceMalfunction',
  DonationWithdrawnByOPO = 'DonationWithdrawnByOPO',
  SurgicalError = 'SurgicalError',
  Other = 'Other',
}

export enum DispositionSpecificationType {
  None = 'None',
  DonorReasons = 'DonorReasons',
  RecipientReasons = 'RecipientReasons',
  LogisticsCosts = 'LogisticsCosts',
  AcceptedAlternateDonor = 'AcceptedAlternateDonor',
  ChangedToAnAlternatePreservationMethod = 'ChangedToAnAlternatePreservationMethod',
  DonorQuality = 'DonorQuality',
  OrganNotViable = 'OrganNotViable',
  LogisticalIssues = 'LogisticalIssues',
  TXCenterAcceptanceCriteria = 'TXCenterAcceptanceCriteria',
  AlternatePreservationMethod = 'AlternatePreservationMethod',
  OCSContraindicationOrNotSuitable = 'OCSContraindicationOrNotSuitable',
  NoClinicalSpecialists = 'NoClinicalSpecialists',
  NoSurgeon = 'NoSurgeon',
  NoDevice = 'NoDevice',
  TooShortNotice = 'TooShortNotice',
  NoGroundTransport = 'NoGroundTransport',
  NoPlanes = 'NoPlanes',
  Other = 'Other',
}

export enum TurndownOutcome {
  DiscardOrgan = 'DiscardOrgan',
  ShipOrgan = 'ShipOrgan',
  RellocateOrgan = 'RellocateOrgan',
}

export type OutcomeCaseParams = {
  outcomeType: OutcomeType;
  dispositionReason: DispositionReasonType;
  dispositionSpecification: DispositionSpecificationType;
  turndownOutcome?: TurndownOutcome;
  dispositionComment: string;
  outcomeDateTime: DateString | null;
  timeZone: string;
  timestamp: string;
};

export type OutcomeData = {
  id: Uuid;
  sourceType: 'Case' | 'Service';
} & OutcomeCaseParams;
